// Industry demo registry — add future category designs here to extend /demos.
export const DEMO_THEMES = {
  restaurant: {
    id: "restaurant",
    slug: "restaurant",
    route: "/demos/restaurant",
    vertical: "Dining & Hospitality",
    business: "Aurelia",
    tagline: "Contemporary fine dining",
    accent: "#D4AF37",
    accentText: "#0B0B0C",
    mode: "dark",
    concierge: { name: "Aria", role: "Dining Assistant", badge: "A", accent: "#D4AF37", bg: "#131316", text: "#FAF9F6" },
  },
  "real-estate": {
    id: "real-estate",
    slug: "real-estate",
    route: "/demos/real-estate",
    vertical: "Real Estate",
    business: "Maya Bennett Local Real Estate",
    tagline: "Warm, local, trusted",
    accent: "#1B4D3E",
    accentText: "#FFFFFF",
    mode: "light",
    concierge: { name: "Haven", role: "Property Assistant", badge: "H", accent: "#1B4D3E", bg: "#F3F3ED", text: "#11181C" },
  },
  medical: {
    id: "medical",
    slug: "medical",
    route: "/demos/medical",
    vertical: "Healthcare",
    business: "Harborlight Medical Clinic",
    tagline: "Care that listens",
    accent: "#2563EB",
    accentText: "#FFFFFF",
    mode: "light",
    concierge: { name: "Clara", role: "Virtual Care Guide", badge: "C", accent: "#2563EB", bg: "#EFF6FF", text: "#0B2447" },
  },
  law: {
    id: "law",
    slug: "law",
    route: "/demos/law",
    vertical: "Professional Services",
    business: "Hartwell & Pierce LLP",
    tagline: "Experienced counsel. Clear direction.",
    accent: "#0B2447",
    accentText: "#C6A15B",
    mode: "light",
    concierge: { name: "Intake Assistant", role: "Legal Intake", badge: "L", accent: "#0B2447", bg: "#F5F3EE", text: "#0B2447" },
  },
  spa: {
    id: "spa",
    slug: "spa",
    route: "/demos/spa",
    vertical: "Spa & Wellness",
    business: "Stillwater Spa & Massage",
    tagline: "Return to your natural rhythm",
    accent: "#5E6F55",
    accentText: "#FFFFFF",
    mode: "light",
    concierge: { name: "Willow", role: "Spa Assistant", badge: "W", accent: "#5E6F55", bg: "#F6F4EF", text: "#33372C" },
  },
  fashion: {
    id: "fashion",
    slug: "elara",
    route: "/demos/elara",
    vertical: "Fashion E-commerce",
    business: "ELARA & IVY",
    tagline: "Quiet confidence, beautifully made",
    accent: "#8A7B6B",
    accentText: "#FFFFFF",
    mode: "light",
    concierge: { name: "Elle", role: "Personal Shopping Stylist", badge: "E", accent: "#8A7B6B", bg: "#FBF8F3", text: "#3A342D" },
  },
  charity: {
    id: "charity",
    slug: "charity",
    route: "/demos/charity",
    vertical: "Charity / Nonprofit",
    business: "Harvest Bridge",
    tagline: "Good food belongs on every table",
    accent: "#2F6B3A",
    accentText: "#FFFFFF",
    mode: "light",
    concierge: { name: "Hope", role: "Supporter Guide", badge: "H", accent: "#2F6B3A", bg: "#F5F7F0", text: "#233024" },
  },
  portfolio: {
    id: "portfolio",
    slug: "portfolio",
    route: "/demos/portfolio",
    vertical: "Portfolio",
    business: "Amara Vale",
    tagline: "Design for a kinder, more human tomorrow",
    accent: "#111111",
    accentText: "#FFFFFF",
    mode: "light",
    concierge: { name: "Vale", role: "AI Résumé & Booking", badge: "V", accent: "#2563EB", bg: "#F6F5F1", text: "#1A1A1A" },
  },
  hotel: {
    id: "hotel", slug: "hotel", route: "/demos/hotel", vertical: "Hotel & Resort", business: "Solara Cove Resort",
    tagline: "Where the coast slows time", accent: "#1E6F78", accentText: "#FFFFFF", mode: "light",
    concierge: { name: "Sola", role: "Travel Assistant", badge: "S", accent: "#1E6F78", bg: "#F3F7F6", text: "#173B3E" },
  },
  salon: {
    id: "salon", slug: "salon", route: "/demos/salon", vertical: "Salon & Beauty", business: "Lumé Hair & Nail Spa",
    tagline: "Beauty, styled for you", accent: "#B58A5A", accentText: "#FFFFFF", mode: "light",
    concierge: { name: "Coco", role: "Beauty Assistant", badge: "C", accent: "#B58A5A", bg: "#FBF6F0", text: "#3A2E22" },
  },
  grocery: {
    id: "grocery", slug: "fresh", route: "/demos/fresh", vertical: "Grocery E‑commerce", business: "Fresh Market",
    tagline: "Fresh food, better prices", accent: "#2F8F3E", accentText: "#FFFFFF", mode: "light",
    concierge: { name: "Basil", role: "Grocery Helper", badge: "B", accent: "#2F8F3E", bg: "#F4F8F1", text: "#1F3322" },
  },
  auto: {
    id: "auto", slug: "auto", route: "/demos/auto", vertical: "Auto Repair", business: "Precision Auto Care",
    tagline: "Your car, our expertise", accent: "#C0242E", accentText: "#FFFFFF", mode: "dark",
    concierge: { name: "Max", role: "Service Advisor", badge: "M", accent: "#C0242E", bg: "#14161A", text: "#F4F4F5" },
  },
  college: {
    id: "college", slug: "college", route: "/demos/college", vertical: "Higher Education", business: "Cedar Grove College",
    tagline: "Find your path. Build what comes next.", accent: "#2E6B4F", accentText: "#FFFFFF", mode: "light",
    concierge: { name: "Grove", role: "Admissions Assistant", badge: "G", accent: "#2E6B4F", bg: "#F1F6F2", text: "#1C3327" },
  },
  saas: {
    id: "saas", slug: "saas", route: "/demos/saas", vertical: "SaaS Product", business: "Nexora",
    tagline: "AI work, without the busywork.", accent: "#7C5CFF", accentText: "#FFFFFF", mode: "dark",
    concierge: { name: "Nova", role: "Product Guide", badge: "N", accent: "#7C5CFF", bg: "#0E0B1E", text: "#EDEBFF" },
  },
};

export const DEMO_LIST = Object.values(DEMO_THEMES);
